import React from 'react';

import ChevronIcon from '../../images/Chevron';

import { Button } from './Button';

import style from './ScrollUpButton.scss';

import cn from 'classnames';

interface IScrollButtonProps {
  className?: string;
}

function scrollToTop() {
  const topOfWindow = document.documentElement.scrollTop || document.body.scrollTop;

  if (topOfWindow > 0) {
    window.requestAnimationFrame(scrollToTop);
    window.scrollTo(0, topOfWindow - topOfWindow / 5);
  }
}

export function ScrollUpButton(props: IScrollButtonProps) {
  const { className } = props;

  return (
    <Button
      className={cn(className, style.scroll)}
      onClick={scrollToTop}
      data-testid="scroll-up-button"
      aria-label="scroll up"
    >
      <ChevronIcon rotate={-90} />
    </Button>
  );
}
